import { Button, Flex, Loader } from '@capioweb/ui-components/src'
import { ContentHubArticlePageBlock, ContentHubArticlePageBlockProps } from '../../ContentHubArticlePageBlock'
import React from 'react'
import { AppContext, LocalesContext } from '../../../context'
import { Articles } from '../ContentHubArticleListingBlock'
import useSSR from 'use-ssr'
import { useQuery } from 'react-query'
import { getAllArticles } from '../../../api/getAllItems'
import { queryStaleTime } from '../../../constants'
import { BlockCommonLayout } from '../../../utils/layout'
import { ArticleFilterContext } from '../context/ArticleFilterContext'

interface ArticleListProps {
    articles: Articles
}

const ArticleList: React.FC<ArticleListProps> = ({ articles }) => {

    const { translate, translationKeys } = React.useContext(LocalesContext)
    const { activeArticleIds, data, isLoading } = React.useContext(ArticleFilterContext)
    const [showAll, setShowAll] = React.useState(false)
    const [activeArticles, setActiveArticles] = React.useState(articles?.items)



    React.useEffect(() => {
        //When clicking on Show all with no filters, show all articles
        if (!isLoading && showAll && activeArticleIds.length <= 0) {
            setActiveArticles(data?.items)
        }
        //When un-checking all filters, show the initial number of articles
        else if (!showAll && activeArticleIds.length <= 0)
            setActiveArticles(articles?.items)
    }, [showAll])

    React.useEffect(() => {
        if (!isLoading && activeArticleIds.length > 0) {
            const filteredArticles = data?.items.filter((item) => item.categories.value?.filter((article) => activeArticleIds.includes(article.id)).length > 0)
            setActiveArticles(filteredArticles)
            setShowAll(true)
        }
        else {
            setShowAll(false)
        }
    }, [activeArticleIds])

    if (isLoading) return <Flex py={20}> <Loader /> </Flex>


    return (
        <BlockCommonLayout>
            <Flex
                w={1}
                flexWrap="wrap"
                justifyContent="space-between"
                alignContent="space-between"
                columnGap={{ m: 3 }}
                rowGap={{ _: 2, m: 3 }}
            >
                {activeArticles?.length > 0 &&
                    activeArticles.map((article, i) => {
                        return (
                            <Flex
                                key={i}
                                flexGrow={1}
                                flexShrink={1}
                                flexBasis={{
                                    _: "100%",
                                    m: i === 0 ? "calc(100%)" : "calc(50% - 24px)",
                                    l:
                                        i === 0
                                            ? "calc(100% / 3 * 2 - 12px)"
                                            : "calc(100% / 3 - 24px)",
                                }}
                            >
                                <ContentHubArticlePageBlock {...article} />
                            </Flex>
                        )
                    })}
            </Flex>
            <Flex
                w={1}
                justifyContent="center"
                display={!showAll ? "flex" : "none"}
            >
                <Button
                    disabled={isLoading}
                    variant="ghost"
                    textColor="navy"
                    icon="plus"
                    onClick={() => {
                        setShowAll(true)
                    }}
                    mt={{ _: 2, l: 5 }}
                >
                    {isLoading
                        ? translate(translationKeys.loadArticles)
                        : translate(translationKeys.showMore)}
                </Button>
            </Flex>
        </BlockCommonLayout>
    )
}

export { ArticleList }